import { BuiltinAtoms } from '@lemon8/web-app-shared/atom';
import { $LegalPageLevelTraffic, $LegalRegion, $Location } from 'shared/atoms/common';
import { $EmailData } from 'shared/atoms/email';
// import { $TTNewsroomTitle } from 'shared/atoms/ban';

export const HydrationAtomsMap = {
  $LegalPageLevelTraffic,
  $LegalRegion,
  $Location,
  $EmailData,
  // $TTNewsroomTitle,
};

export const HydrationAtomFamiliesMap = {};

export const Atoms = {
  ...BuiltinAtoms,
  ...HydrationAtomsMap,
  ...HydrationAtomFamiliesMap,
};

export * from './common';
export * from './email';
export * from './ban';
